const allowedFileMimeTypes = [/^image\/[\w+-]+$/i, /^application\/pdf$/i, /^text\/[\w+-]+$/i];
const allowedFileExtensions = ['.csv'];

export function isFileAllowed(file: File) {
  const inAllowedMime = allowedFileMimeTypes.some((mime) => mime.test(file.type));
  const inAllowedExt = allowedFileExtensions.some((ext) => file.name.endsWith(ext));
  return inAllowedMime || inAllowedExt;
}
